import { ApiClient } from '~/apiClients/ApiClient';
import {
  SoftwareTracker,
  SoftwareTrackerAttributes,
  SoftwareTrackerCreationAttributes,
  SoftwareTrackerUpdateAttributes
} from '~/models/SoftwareTracker';

export default class SoftwareTrackerApiClient extends ApiClient {
  private readonly BASE_URL: string = '/api/software-trackers';

  public async provideSoftwareTrackers(softwareId: number): Promise<SoftwareTracker[]> {
    const response = await this.get(`${this.BASE_URL}?softwareId=${softwareId}`);
    return response.data.map((attributes: SoftwareTrackerAttributes) => new SoftwareTracker(attributes));
  }

  public async provideSoftwareTracker(trackerId: number): Promise<SoftwareTracker> {
    const response = await this.get(`${this.BASE_URL}/${trackerId}`);
    return new SoftwareTracker(response.data || {});
  }

  public async createSoftwareTracker(attributes: SoftwareTrackerCreationAttributes) {
    return this.post(this.BASE_URL, attributes);
  }

  public async cloneSoftwareTracker(id: number): Promise<SoftwareTracker> {
    const response = await this.post(`${this.BASE_URL}/clone`, { id });
    return new SoftwareTracker(response.data);
  }

  public async updateSoftwareTracker(attributes: SoftwareTrackerUpdateAttributes) {
    const response = await this.patch(this.BASE_URL, attributes);
    return new SoftwareTracker(response.data);
  }
}
